import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

type Props = {
  user: User
}

const useComputeRoute = (user: User) => {
  const { navigation } = useNavigation()

  if (user.isCurrent()) return navigation.profile.fullPath()

  const employee = user.employee

  if (!employee) return null

  return navigation.employees.id.fullPath({ id: employee.attributes.id })
}

export const EmployeeProfileButton: React.FC<Props> = ({ user }) => {
  const route = useComputeRoute(user)

  return (
    route && (
      <Button.Router type="secondary" to={route}>
        {i18n.t('surveys.review.reviews.reviewee.view_profile')}
      </Button.Router>
    )
  )
}
